@if (ls.restaurantWidgetSettings$.value.WidgetCustomization.HeaderStyle != headerStyle.none) {
  <div class="header"
  [ngStyle]="{'background-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.TopHalfBackgroundColor,'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.TitleTextColor,
  'font-family': ls.restaurantWidgetSettings$.value.WidgetCustomization.HeaderFont,
  'font-size': ls.restaurantWidgetSettings$.value.WidgetCustomization.HeaderFontSize+'px'}">
    <div class="header__header-info" tabindex="0">
      @if ((ls.restaurantWidgetSettings$.value.WidgetCustomization.HeaderStyle == headerStyle.agilysys || ls.restaurantWidgetSettings$.value.WidgetCustomization.HeaderStyle == headerStyle.cityEats)) {
        <img class="header__agilysys-logo" src="assets/images/Reserve_Dark_Logo.png" alt="logo-img"/>
      }
      <span class="page-title">{{ls.restaurantWidgetSettings$.value.WidgetCustomization.HeaderText}}</span>
    </div>
    <!--Needed for language-->
    <div [hidden]="!IsMultiLanguageSelectionEnabled || !gs.showLanguageOption || gs.currentComponentName != componentName.reservationDetails" [ngStyle]="{'display': hideLanguageOption ? 'none' : 'flex', 'align-items': 'center'}">
      <span class="header__language-label default-sub-header" [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.TitleTextColor}">{{'language' | translate}}</span>
        <dynamic-form [config]="languageConfig"></dynamic-form>
    </div>
  </div>
}
@if (ls.restaurantWidgetSettings$.value.WidgetCustomization.HeaderStyle == headerStyle.none) {
  <div class="header header__none">
    <!--Needed for language-->
    <div [hidden]="!IsMultiLanguageSelectionEnabled || !gs.showLanguageOption" style="  display: flex; align-items: center;">
      <span class="header__language-label default-sub-header" [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.TitleTextColor}">{{'language' | translate}}</span>
        <dynamic-form [config]="languageConfig"></dynamic-form>
    </div>
  </div>
}